/**
 * RESPONSIBILITY: draw one person as a card.
 *
 * The children's team and the leadership team are different lists of the same thing, so
 * they draw the same card. Changing what a person looks like is one edit.
 */
import type { Person } from '@app/sections';
import { Picture } from './Picture';

export function PersonCard({ p }: { p: Person }) {
  return (
    <div className="card">
      <Picture value={p.photo} alt={p.name} className="card-pic" />
      <div className="card-body">
        <h3>{p.name}</h3>
        <p className="meta">{p.role}</p>
      </div>
    </div>
  );
}
